import React, {useEffect, useState} from 'react';
import {ReactComponent as CalendarIcon} from '../../../../assets/main/groups/main-table/period-calendar/calendar.svg';
import {ReactComponent as PlusIcon} from '../../../../assets/main/groups/main-table/period-calendar/plus.svg';

import {Link} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "common/hook";
import {Select} from "antd";
import {ReactComponent as SelectArrayIcon} from '../../../../assets/i/select-array-icon.svg';

import {ReactComponent as ArrowUpIconIcon} from '../../../../assets/i/arrow-up-icon.svg';
import {CalendarWith} from "../../groups/group-container/main-table/period-calendar/calendar-with/Calendar-with";
import {CalendarTo} from "../../groups/group-container/main-table/period-calendar/calendar-to/Calendar-to";
import {ROLE_TEACHER} from "entities/constants/constants";
import {CompanySummaryTable} from "features/model/types/hr/getSummaryTable";
import {StatisticsGroup} from "features/model/types/hr/getStatistics";
import {Options} from "components/form/options/options";
import {getStatistics} from "features/model/service/hr/get-statistics/getStatistics";
import {getStatisticsExcel} from "features/model/service/hr/get-statistics-excel/getStatisticsExcel";

interface IPeriodCalendar {
    create: boolean
    print: boolean
    company?: CompanySummaryTable
    groups?: StatisticsGroup[]
}

export const StatusCalendar = ({create, print, company, groups}: IPeriodCalendar) => {
    const dispatch = useAppDispatch()
    const roleType = useAppSelector((state) => state.role.roleType);
    const [isOpenWith, setIsOpenWith] = useState(false);
    const [isOpenTo, setIsOpenTo] = useState(false);
    const [open, setOpen] = useState<boolean>(false);
    const [selectedGroup, setSelectedGroup] = useState<string | undefined>(undefined);
    const from = useAppSelector((state) => state.date.dateWith);
    const to = useAppSelector((state) => state.date.dateTo);
    const fromNew = useAppSelector((state) => state.date.dateWithNew);
    const toNew = useAppSelector((state) => state.date.dateToNew);
    const [group_idNumber, setGroupIdNumber] = useState<number | null | undefined>(null);

    useEffect(() => {
        const group_idNumber = selectedGroup ? parseInt(selectedGroup, 10) : null;
        setGroupIdNumber(group_idNumber);
        dispatch(getStatistics({from, to, group_id: group_idNumber}));
    }, [selectedGroup]);


    useEffect(() => {
        if (from && to) {
            dispatch(getStatistics({from, to}));
        }
    }, [from, to]);


    const optionsGroups: Options[] = [
        {value: null, label: "Все группы"},
        ...(groups?.map((group) => ({value: group.id, label: group.title})) || []),
    ];


    const onClickHandler = () => {
        setOpen(!open)
    }


    const togglePopupWith = () => {
        setIsOpenWith(!isOpenWith);
        setIsOpenTo(false);
    };

    const togglePopupTo = () => {
        setIsOpenTo(!isOpenTo);
        setIsOpenWith(false);
    };

    const handleClose = () => {
        setIsOpenWith(false);
        setIsOpenTo(false);
    };

    const downloadExcelHandler = () => {
        dispatch(getStatisticsExcel({
            from,
            to,
            group_id: group_idNumber ?? undefined,
        }));
    }


    return (
        <div className="tabs-content">
            {print &&
                <div className="data-tbl-title-box">
                    <div className="title-col">
                        <p className="h3">{company?.title}</p>
                    </div>
                    <div className="sub-col">
                        <span
                            className="btn secondary small print-action"
                            onClick={downloadExcelHandler}
                        >
                            <span>Распечатать отчёт</span>
                        </span>
                    </div>
                </div>
            }
            <div className="tab">
                <div className="data-tbl-controls">
                    <div className="period-control">
                        <span className="text">Период с</span>
                        <span onClick={togglePopupWith} className="open-calendar-btn">
                            <span className='date-width'>{fromNew || null}</span>
                            <CalendarIcon/>
                        </span>
                        <span className="text">по</span>
                        <span onClick={togglePopupTo} className="open-calendar-btn">
                            <span className='date-width'>{toNew || null}</span>
                            <CalendarIcon/>
                        </span>
                    </div>

                    {roleType === ROLE_TEACHER &&
                        <>
                            {create &&
                                <Link to="/groups/add-lesson" className="btn small has-icon">
                            <span className="icon">
                                <PlusIcon/>
                             </span>
                                    <span>Создать занятие</span>
                                </Link>

                            }
                        </>
                    }
                    <div id="group" className="data-tbl-filter" onClick={onClickHandler}>
                        <span className="filter-item active group-line">Группа</span>
                        <Select
                            className="filter-item"
                            defaultValue="Выберите группу"
                            style={{width: 'auto'}}
                            bordered={false}
                            options={optionsGroups}
                            onChange={(value: string) => setSelectedGroup(value)}
                            suffixIcon={open ? <ArrowUpIconIcon/> : <SelectArrayIcon/>}
                        />
                    </div>
                </div>
            </div>
            {isOpenWith && <CalendarWith onClose={handleClose}/>}
            {isOpenTo && <CalendarTo onClose={handleClose}/>}
        </div>
    );
};
